import React from 'react';
import { numberToCurrency } from 'utils/misc';
import { roundToTwoDecimals } from 'utils/numbers';
import { InfoWidget } from '@ds/react-components';
import { List as ListLoader } from 'react-content-loader';
import InfoWidgetTextRow from '../common/InfoWidgetTextRow';
import SuspensionRulesNote from './SuspensionRulesNote';

const SuspensionRules = (props) => {
  const { suspensionInfo, localisation, suspensionRuleLoading } = props;

  const {
    allowedSuspensionPeriod,
    suspensionFee,
    nextAnniversaryStartDate,
    currentAnniversaryRemainingSuspension,
  } = suspensionInfo;

  const loaderStyle = {
    height: '130',
    width: '100%',
  };

  return (
    <InfoWidget
      title="Suspension Rules"
      collapsible={true}
      isOpen={true}
      isLoading={suspensionRuleLoading}
      contentLoader={<ListLoader style={loaderStyle} />}>
      {suspensionFee !== null ? (
        <InfoWidgetTextRow
          title={'Suspension Fee'}
          value={numberToCurrency(
            roundToTwoDecimals(suspensionFee),
            localisation
          )}
        />
      ) : null}
      {allowedSuspensionPeriod !== null ? (
        <>
          <InfoWidgetTextRow
            title={'Remaining Suspension Period'}
            value={`${currentAnniversaryRemainingSuspension} days (from a total of ${
              allowedSuspensionPeriod * 7
            } days)`}
          />
          <SuspensionRulesNote
            nextAnniversaryStartDate={nextAnniversaryStartDate}
          />
        </>
      ) : null}
    </InfoWidget>
  );
};

export default SuspensionRules;
